export default API => ({
    getCmsContent(data) {
      return API({
        url: `/cms/v1/special/getSpecialContent`,
        method: 'post',
        params: data
      })
    }
  });